const Emitter = require('mn-utils/Emitter');
const get = require('mn-utils/get');
const find = require('mn-utils/find');
const {
  apiAppList,
} = require('../api/merchant/app');
const {
  popup$,
} = require('./popup');

export const widgetsRequestSuccess$ = popup$.is('widgets_request_success');
export const loadingWidgets$ = new Emitter();


export function updateWdgets() {
  loadingWidgets$.emit(1);
  return apiAppList()
      .then(widgets$.emit)
      .then(loadingWidgets$.bind(0));
}

export const widgets$ = new Emitter(updateWdgets, []);
export const defaultWidgetId$ = widgets$
    .map((apps) => get(find(apps, ['by_default', true]), 'id'));
